import { CompanyStore } from "../models/company.store.model";
import api from "../lib/api";
import { Pagination, TableApiRes } from "../models/base.model";
import { deleteConfirmDialog } from "./common.action";

export async function getCompanyStores(
  param?: Pagination
): Promise<TableApiRes<CompanyStore>> {
  const result = await api<{
    stores: CompanyStore[];
    offset?: any;
    total?: number;
  }>({
    url: `/company-stores/filter`,
    method: "POST",
    data: param || { limit: 50 },
  });
  const data = result.stores;
  return {
    data,
    total: result.total,
    offset: result.offset,
  };
}

export async function getAllowedCompanyStores(): Promise<CompanyStore[]> {
  const result = await api<{
    stores: CompanyStore[];
  }>({
    url: `/company-stores/allowed`,
    method: "GET",
  });
  return result.stores;
}

export async function addCompanyStore(
  param: CompanyStore,
): Promise<CompanyStore> {
  const data = (
    await api<{ store: CompanyStore }>({
      url: `/company-stores`,
      data: param,
      method: "POST",
    })
  ).store;
  return data;
}

export async function updateCompanyStore(param: Partial<CompanyStore>) {
  const data = (
    await api<{ store: CompanyStore }>({
      url: `/company-stores/${param.id}`,
      data: param,
      method: "PATCH",
    })
  ).store;
  return data;
}

export async function deleteCompanyStore(id: string, companyId: string) {
  await deleteConfirmDialog(() =>
    api({
      url: `/company-stores/${id}`,
      method: "DELETE",
      data: {
        sk: companyId,
      },
    }),
  );
}

export async function batchCreateCompanyStores(params: {
  stores: CompanyStore[];
}) {
  if (params.stores.length === 0) {
    throw new Error("No store found to import, please upload and try again!");
  }
  const data = (
    await api<{ stores: CompanyStore }>({
      url: `/company-stores/batch`,
      data: params,
      method: "POST",
      message: `Successfully batch import ${params.stores.length} company stores`,
    })
  ).stores;
  return data;
}

export async function getAllowedStores() {
  const data = await api<{ stores: CompanyStore[] }>({
    url: `/company-stores/allowed`,
    method: "GET",
  });
  return data.stores;
}